import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddIcon } from '../../../assets/icons';
import CreateClassDialog from '../../../components/createClassDialog/CreateClassDialog';
import PageTitleWithTooltip from '../../../components/pageTitleWithTooltip/PageTitleWithTooltip';
import Table from '../../../components/table/Table';
import PageWithHeader from '../../../layouts/pageWithHeader/PageWithHeader';
import { useAnalysis } from '../../../utils/contexts/AnalysisContext';

import EmptyStudentAnalysis from './components/emptyStudentAnalysis/EmptyStudentAnalysis';
import SelectStudentsOrder from './components/SelectStudentsOrder/SelectStudentsOrder';
import SelectStudentsTimeRange from './components/SelectStudentsTimeRange/SelectStudentsTimeRange';
import StudentsAnalysisTooltip from './components/StudentsAnalysisTooltip/StudentsAnalysisTooltip';
import './studentsPage.scss';
import useStudentsPage from './useStudentsPage';

const StudentsPage = ({ isMock = false }) => {
  const { t } = useTranslation();
  const {
    columns,
    usersData,
    isLoading,
    selectedOrderBy,
    selectedTimeRange,
    setSelectedOrderBy,
    setSelectedTimeRange
  } = useStudentsPage(isMock);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { ANALYSIS_SEGMENT } = useAnalysis();

  return (
    <div className='students-page'>
      <PageWithHeader
        left={
          <PageTitleWithTooltip
            title={t('students_analysis')}
            testId='students-page-heading'
          />
        }
        right={
          <div className='students-page__filters-container'>
            <SelectStudentsOrder
              selectedOrderBy={selectedOrderBy}
              onChange={setSelectedOrderBy}
            />
            <SelectStudentsTimeRange
              selectedTimeRange={selectedTimeRange}
              onChange={setSelectedTimeRange}
            />
          </div>
        }
        tooltip={<StudentsAnalysisTooltip />}
        pageName={ANALYSIS_SEGMENT.PAGE_NAMES.Students_Analysis_Page}
      >
        <Table
          data={usersData}
          columns={columns}
          isLoading={isLoading}
          testId='students-analysis-table'
        />

        {/* TODO: refactorizar esta funcionalidad para no tener que instanciar CreateClassDialog 2 veces */}
        <div className='create-your-class-button-container'>
          <button
            className='dashboard-topbar__button dashboard-topbar__button--outlined dashboard-topbar__button--small'
            onClick={() => setIsDialogOpen(true)}
          >
            {t('button_create_your_own_class')}
            <AddIcon width={24} height={24} style={{ marginLeft: '0.5em' }} />
          </button>
        </div>

        <CreateClassDialog
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
        />

        {!isLoading && usersData.length === 0 && <EmptyStudentAnalysis />}
      </PageWithHeader>
    </div>
  );
};

export default StudentsPage;
